import { OpeningVisibilityEnum } from '@src/graphql/generated';

export const ARCHIVE_OPENING = 'ARCHIVE_OPENING';
export const UPDATE_OPENING_STATE = 'UPDATE_OPENING_STATE';

export const EMPLOYMENT_TYPES = {
  FULL_TIME: { key: 'FULL_TIME', name: 'Full-time' },
  INTERNSHIP: { key: 'INTERNSHIP', name: 'Internship' },
  PART_TIME: { key: 'PART_TIME', name: 'Part-time' },
  PROJECT: { key: 'PROJECT', name: 'Project / Freelance' },
};

export const OPENING_VISIBILITY = {
  PUBLIC: { key: OpeningVisibilityEnum.PUBLIC, name: 'Public' },
  UNLISTED: { key: OpeningVisibilityEnum.UNLISTED, name: 'Unlisted' },
};

export const WORK_LOAD_PERIOD = {
  TOTAL: 'TOTAL',
  WEEK: 'WEEK',
};

export const CANDIDATE_DESTINATION_TYPES = {
  GQL: {
    EXTERNAL_URL: 'EXTERNAL_URL',
    MEETFRANK: 'MEETFRANK',
  },
  HR_APP: {
    EXTERNAL_URL: 'external-url',
    MEETFRANK: 'meetfrank',
  },
};
